// src/context/LanguageContext.js
import React, { createContext, useState, useContext } from "react";
import en from "../textContent/en.json";
import de from "../textContent/de.json";
import tr from "../textContent/tr.json";

// Erstelle den Context
const LanguageContext = createContext();

// Übersetzungen
const translations = {
  en: en,
  de: de,
  tr: tr,
};

export const useLanguage = () => useContext(LanguageContext);

// Erstelle den Provider
export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState("de");

  const t = (key) => {
    return key.split(".").reduce((o, i) => (o ? o[i] : null), translations[language]);
  };

  const switchLanguage = (lang) => {
    setLanguage(lang);
  };

  return (
    <LanguageContext.Provider value={{ t, switchLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};
